// extracted by mini-css-extract-plugin
module.exports = {"Mascots":"Mascots_Mascots__W368r","images":"Mascots_images__vzZoe"};